var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterToExclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49929 12.9117C7.44564 12.9581 7.38037 12.9876 7.31112 12.9969C7.24187 13.0061 7.17151 12.9947 7.10827 12.964C7.04504 12.9333 6.99155 12.8845 6.95407 12.8234C6.91659 12.7623 6.89668 12.6914 6.89665 12.619V7.60044C5.71802 7.35063 4.6505 6.70785 3.85685 5.77012C3.06321 4.83239 2.58699 3.65117 2.50082 2.40657C2.49746 2.3545 2.50445 2.30228 2.52135 2.25313C2.53825 2.20398 2.56469 2.15895 2.59905 2.12084C2.63341 2.08272 2.67494 2.05233 2.72109 2.03155C2.76723 2.01076 2.81699 2.00002 2.8673 2H13.1327C13.183 2.0001 13.2327 2.01088 13.2789 2.0317C13.325 2.05251 13.3665 2.0829 13.4008 2.121C13.4352 2.1591 13.4616 2.20409 13.4785 2.25321C13.4955 2.30233 13.5025 2.35452 13.4992 2.40657C13.413 3.65148 12.9365 4.83296 12.1425 5.77073C11.3485 6.70851 10.2804 7.3511 9.10142 7.60044V8.77704",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94824 13.6667L11.9482 10.6667",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9482 13.6667L8.94824 10.6667",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterToExclude);
export default __webpack_public_path__ + "static/media/filter-to-exclude.67d6b1676d23feb6a9748862b0e277c1.svg";
export { ForwardRef as ReactComponent };